import { Skeleton, SkeletonText } from '@dev-spendesk/grapes';

export const StayResultsSkeleton = () => {
  return (
    <div className="flex w-full flex-col gap-24">
      {[1, 2, 3].map((index) => (
        <div
          key={index}
          className="rounded-12 border-border-default bg-background-primary-default flex w-full gap-16 border p-16"
        >
          <Skeleton
            width="200px"
            height="200px"
            className="rounded-8 shrink-0"
          />
          <div className="flex flex-1 flex-col gap-4">
            <SkeletonText size="xxl" width="240px" />
            <div className="flex items-center gap-4">
              <SkeletonText size="m" width="64px" />
            </div>
            <SkeletonText size="m" width="96px" />
            <div className="mt-auto flex flex-col gap-8">
              <SkeletonText size="m" width="56px" />
              <SkeletonText size="xxl" width="120px" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
